import { gql } from "@apollo/client";

import { AssessmentGroupFragment } from "@apps/assessments/graphql/get-assessment-groups-query";

export default gql`
  ${AssessmentGroupFragment}
  mutation saveFullAssessmentGroup(
    $title: String
    $assessmentGroupId: Int
    $organizationId: Int
    $assessmentType: AssessmentType
    $sections: [FullAssessmentGroupSectionInput]!
  ) {
    createOrUpdateFullAssessmentGroup(
      organizationId: $organizationId
      assessmentGroupId: $assessmentGroupId
      assessmentType: $assessmentType
      title: $title
      sections: $sections
    ) {
      assessmentGroup {
        ...AssessmentGroupFragment
      }
    }
  }
`;
